var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanetClouds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "g1",
    cx: 117.1,
    cy: 170.1,
    r: 121.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ecfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g2",
    cx: 115.2,
    cy: 209.9,
    r: 136.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aac2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g3",
    cx: 199.8,
    cy: 49.5,
    r: 84.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ecfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g4",
    cx: 207.1,
    cy: 111,
    r: 285.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aac2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g5",
    cx: 186.8,
    cy: 342.6,
    r: 156.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ecfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g6",
    cx: 198.4,
    cy: 422.7,
    r: 144.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aac2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g7",
    cx: 84,
    cy: 309.3,
    r: 63.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ecfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g8",
    cx: 78,
    cy: 329.5,
    r: 69.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aac2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g9",
    cx: 252.1,
    cy: 166.2,
    r: 188.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ecfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g10",
    cx: 271.4,
    cy: 188.5,
    r: 191.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aac2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g11",
    cx: 369.1,
    cy: 243.1,
    r: 191.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ecfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g12",
    cx: 423.7,
    cy: 271.9,
    r: 254.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aac2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g13",
    cx: 345.5,
    cy: 424.2,
    r: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ecfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g14",
    cx: 368.4,
    cy: 441,
    r: 166.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aac2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: url(#g1) } \r\n\t\t.s1 { mix-blend-mode: multiply;fill: url(#g2) } \r\n\t\t.s2 { fill: url(#g3) } \r\n\t\t.s3 { mix-blend-mode: multiply;fill: url(#g4) } \r\n\t\t.s4 { fill: url(#g5) } \r\n\t\t.s5 { mix-blend-mode: multiply;fill: url(#g6) } \r\n\t\t.s6 { fill: url(#g7) } \r\n\t\t.s7 { mix-blend-mode: multiply;fill: url(#g8) } \r\n\t\t.s8 { fill: url(#g9) } \r\n\t\t.s9 { mix-blend-mode: multiply;fill: url(#g10) } \r\n\t\t.s10 { fill: url(#g11) } \r\n\t\t.s11 { mix-blend-mode: multiply;fill: url(#g12) } \r\n\t\t.s12 { fill: url(#g13) } \r\n\t\t.s13 { mix-blend-mode: multiply;fill: url(#g14) } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m159.9 67.8c-1.8 26.9-102.2 186.5-123.8 178.4-13.1-4.9-27.2-37.8-18.4-58.1 2.4-5.6 6.7-8.8 12.7-8.3-7.9-22.5-11.5-50.7 3.3-70.7 10-13.4 26.7-15.4 36.9-9.7 5.5-17.2 19.7-48.9 44.5-46.1 8.9 1 9.6 7.9 8.3 12.7 2.7-3.7 6.4-7.1 10.8-9.3 10.9-5.5 26.7-4.7 25.7 11.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m35.4 191.3c-6-30-11.5-88.6 33.5-85.8-1.2 4.5-2.1 8.3-3.2 13.6 11.6-30.1 32-67.2 49.2-58.2 2.8 1.5 5.3 9.1 3.8 15.2 23.2-30.3 40.6-14.7 33.7 13.1-24 51.6-98.1 163.8-116.3 157-2.3-0.8-4.6-2.5-6.8-4.8-11.5-16.6-16-62.3 3.1-57.3q1.5 3.6 3 7.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m164.9 14.6c7.2-10.4 19.3-9.4 28.7-4.6 11.6-9.4 32.8 2.1 31.5 11.1-0.2 1.6-1.4 2.9-4.2 3-9.2 0.3-12.9 0.3-21.7 2.7-8.2 2.4-22.3 9.5-28 10.5-15.9 2.6-11.9-14.6-6.3-22.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m195.7 21.9c-0.3-3.3 1.1-8.9 7.3-9.6 6.1-0.7 23.7 6.7 15.7 11.9-7.7 0.2-11.4 0.4-19.5 2.6-8.2 2.4-22.3 9.5-28 10.5q-1.5 0.2-2.7 0.2c-7.2-2.5-5.1-13.5 2-17.9 8-4.9 18.4-1.5 25.2 2.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m100.2 373.5c-7.3-8.9-19.5-29.7-15.5-53.7 3.4-21.2 19-20.7 24.8-18-0.6-17 4.9-35 17.4-46.1 16.1-14.5 30.2 1.5 24.9 13.9-20.2 47.4-33.6 77.6-11.5 131 16.3 39.2 49 72.5 83.7 90.3-35.1 12.7-79.9-3.7-111-41.1-10.3-12.3-17.4-32.1-6.6-38.4-6.6-2.1-15.5-11.2-17.2-21.4-1.2-6.8 1.9-14.8 11-16.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m140.3 400.6c16.3 39.2 49 72.5 83.7 90.3-8.3 3-17.1 4.4-26.1 4.2-52.1-6.2-103.6-56.1-81.6-82.8-18-1.5-34-26.9-8.2-32.5-17.8-20.4-27-71.4 8.5-60.2-4.2-9.5-4.2-27.7 4.6-39.8 11.4-15.5 22.8-8.2 22 10.2-14.8 36.7-21.7 65.3-2.9 110.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m19.4 304.7c-1.1-20.5 12.5-34.1 30.5-40-5.1-8.6-7.1-16.2-0.7-27.5 3.4-5.9 14.9-18.3 22-19.1 6-0.7 4.8 2.8 4.2 4.8-3 9.4-7.3 18.8-9.7 28.5-13.3 53.5-6.6 70.4-12 83.3-4.5 10.8-32.8-3.2-34.3-30z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m52.1 265.7c9.9 1 6.9-10.7 8.8-19.7 2.6-12.7 7.9-22.3 7.2-24.4-0.3-1.2-4.3 0.3-10.5 5.3 4.5-4.4 9.7-8.4 13.6-8.8 6-0.7 4.8 2.8 4.2 4.8-3 9.4-7.3 18.8-9.7 28.5-13.3 53.5-6.6 70.4-12 83.3-4.5 10.8-32.8-3.2-34.3-30-0.4-7.9 1.3-14.7 4.7-20.5-4.8 14.3-3.8 34.7 15.8 25.2 17.3-8.5 21-27.4 12.2-43.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m128.5 179.3c2.4-11.2 12.1-21.4 21.8-27.6-6.6-3.6-19.6-16.3-2.5-38.4 16.5-21.4 50.2-34.8 58.7-12.1 5.3-5.8 11.5-10.1 19.2-8.7 3.3 0.7 6 3.4 7.4 6.8 3.6-12.6 21.2-32.5 45.3-29.6 31.5 3.8 37.3 33.1 4.8 44.7-22 7.9-42.1 6.9-67.2 18.1-26.5 11.8-38.7 19.6-54.6 43.4-3 4.5-5.2 9.7-8.5 14.1-13 17.5-28.6 9.2-24.4-10.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m153.6 152.2c22.1 5.3 53-15.5 52.4-46.9 2.4 19.7 22.7 18.8 26.4 1.4 3.5 7.1 8.3 9.9 14.2 10.7 15.8 2.1 32.6-3.6 42.8-12 13.7-11.3 13.9-30.3-13.4-35.9q1.2 0 2.4 0.2c31.5 3.8 37.3 33.1 4.8 44.7-22 7.9-42.1 6.9-67.2 18.1-26.5 11.8-38.7 19.6-54.6 43.4-3 4.5-5.2 9.7-8.5 14.1-10.7 14.4-23.1 11.3-24.9-1.3 2.8 7.7 8.8 7.8 14.7 4 7.5-4.9 18.7-22.2 18.9-31.1 0.2-4.1-1.9-7.5-8-9.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m431.7 162.6c-19.5 12.9-28.9 31.6-42 41.4-11.7 8.6-23 0-28.5-3.8-14.7-10.1-25.9 6.5-33.4 19.2-12.5 21-18.4 55.9-47.5 58.6-29 2.7-47.5-25.5-31.1-64 18.8-44.3 68.5-62.7 102.6-54.4 1.7-15.3 12-22 22.3-15.6-2.3-8.6-0.4-17.2 4.2-23.4 12.6-16.9 46.6-11.1 53.7 6.3 24.2-28 67.1 7.8 48.9 43.1-6.5-23.8-28.8-20.8-49.2-7.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m370.1 177.8c2.2 5.1 5.4 8 9.1 9.2 12.1 3.6 27.9-7.5 17.7-22.6-2.7-4.1-7-7.9-12.3-11.4 21.1 12.2 47.3 6.7 47.9-20.9 8.3 6.2 28.3 14.4 36.8 9 8.4-5.3 3.2-13.9-1.7-19.8 14.4 8.6 23.6 28.7 13.3 48.7-6.5-23.8-28.8-20.8-49.2-7.4-19.5 12.9-28.9 31.6-42 41.4-11.7 8.6-23 0-28.5-3.8-14.7-10.1-25.9 6.5-33.4 19.2-12.5 21-18.4 55.9-47.5 58.6-25.9 2.4-43.3-19.8-35.3-51.8-1.7 46.7 37.3 41 61.3 4.7 13-19.8 20.1-46.1 43.2-56.4 8.1-3.6 17.1-4.9 20.6 3.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m359.4 474.9c-71.3 53.1-134.1-49.9-81.8-69.8-13.9-45.9 18.4-101.2 52.6-93.2 8 1.8 15.8 9 16.9 23.1 8.3-30.1 52.4-55 57.7-23.2 23.5-42.7 80-39.9 63.7 28.3-6.9 28.9-16.7 45.2-30.3 60.7-24.6 28.2-76.4 22.3-34.9-25.9 2.6-3 8.6-10.6 14.1-18.7 11.6-16.8 14.1-38.1-11.6-28-6.9 2.7-16.8 11.2-22 13.8-13 6.5-19.9 5.8-32.3 13.4-34.4 21.1-23.4 37.1-21.1 56.1 1.5 12.7-2.2 17.2-6.9 20.3-12.7 8.2-21.8 20.3-11.8 35.8 8.5 13.1 32.1 16 47.7 7.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m359.4 474.9c-40.2 23.5-90.6-12.3-78.4-45.5 3.6-9.6 13.3-15.2 26.1-13.4-7-16.3-10.5-35.5-6.1-55.3 7.6-33.5 42.9-50 44-8.4 8.8-33.9 62.8-62.2 56.3-26.5 16.2-20.3 32.3-21.8 42.8-13.9 26.2 19.6 10.3 69-13.1 94-4.6 5-9.8 8.2-16.3 10.1-22.3 6.7-41.7-5.9-11.4-41.1 2.6-3 8.6-10.6 14.1-18.7 11.6-16.8 14.1-38.1-11.6-28-6.9 2.7-16.8 11.2-22 13.8-13 6.5-19.9 5.8-32.3 13.4-34.4 21.1-23.4 37.1-21.1 56.1 1.5 12.7-2.2 17.2-6.9 20.3-12.7 8.2-21.8 20.3-11.8 35.8 8.5 13.1 32.1 16 47.7 7.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetClouds);
export default __webpack_public_path__ + "static/media/planet-clouds.c090f5c682ba732d4a496107d7f6f41e.svg";
export { ForwardRef as ReactComponent };